import { Link, useNavigate } from 'react-router-dom';
import engineeringConsultancy from '../Assets/Images/Services/engineering-consultancy.png';
import itServices from '../Assets/Images/Services/it-services.png';
import cloudServer from '../Assets/Images/Services/cloud-server.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLongArrowRight } from '@fortawesome/free-solid-svg-icons';

function ServicesCategories() {
    const navigate = useNavigate();

    const displayedServices = [
        {
            title: "Engineering Solutions",
            icon: 'https://miro.medium.com/v2/resize:fit:1200/1*uANnhTXT8zGJWnZp32vRtQ.jpeg',
            description: "Detailed consulting services across various engineering domains.",
            link: "engineering-consultancy",
        },
        {
            title: "IT / Digital Services",
            icon: 'https://static.vecteezy.com/system/resources/thumbnails/023/970/596/small_2x/digital-online-marketing-commerce-sale-concept-promotion-of-products-or-services-through-digital-channels-search-engine-social-media-email-website-digital-marketing-strategies-and-goals-seo-ppc-photo.JPG',
            description: "Building your digital presence and IT infrastructure.",
            link: "digital-services",
        },
        {
            title: "Dedicated Resource Services",
            icon: 'https://www.auxis.com/wp-content/uploads/2024/02/Choosing-a-Help-Desk-Dedicated-vs.-a-Shared-Services-Model-Second-Image-1024x557.jpeg',
            description: "Flexible staffing and resource solutions for your business.",
            link: "dedicated-resources-services",
        },
    ];

    const handleServiceClick = (link) => {
        navigate(`/services/${link}`);
    };

    return (
        <div className="service-area pd-top-112">
            <div className="container">
                <div className="service-area">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-xl-7 col-lg-10 text-center mb-3">
                                <div className="section-title">
                                    <h2 className="title">Services <span>We Offer</span></h2>
                                    <p>
                                        We provide a diverse range of specialized services designed to help businesses grow, innovate, and succeed.
                                        Whether you're looking for expert engineering solution, cutting serviceedge digital solutions, or skilled dedicated resources,
                                        our team is ready to deliver excellence tailored to your needs. Explore our categories below to find the perfect fit for your project.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-lg-12 col-md-12 col-xl-10">
                        <div className="row">
                            {displayedServices.map((service, index) => (
                                <div key={index} className="col-lg-4 col-md-6 mb-4">
                                    <div onClick={() => handleServiceClick(service.link)} style={{ cursor: 'pointer' }} className="single-service">
                                        <img src={service.icon} alt={service.title} />
                                        <h6>{service.title}</h6>
                                        <p className='text-left'>{service.description}</p>
                                        <div className="read-more">
                                            <Link to={service.link}>Read More <FontAwesomeIcon icon={faLongArrowRight} fontSize={15} className='ml-2' /></Link>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ServicesCategories;
